import React from 'react';

import Logo from './Logo';

const WrapperSecondary = ({ title, subtitle, children }) => (
  <div className="o-wrapper o-wrapper--small u-margin-top-large u-margin-bottom-large">
    <div className="u-text-center">
      <Logo className="u-margin-top-large u-margin-bottom-large" />

      {title && <h1>{title}</h1>}
      {subtitle && (
        <p className="c-heading u-margin-bottom-large">{subtitle}</p>
      )}
    </div>

    {children}
  </div>
);

export default WrapperSecondary;



// WEBPACK FOOTER //
// ./src/common/WrapperSecondary.js